import React, { useState } from "react";
import "./App.css";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Brands from "./components/Brands";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Weddings from "./components/Weddings";
import Process from "./components/Process";
import Skills from "./components/Skills";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Lightbox from "./components/Lightbox";
import VideoModal from "./components/VideoModal";
import FloatingContact from "./components/FloatingContact";

function App() {
  const [videoProject, setVideoProject] = useState(null);
  const [lightbox, setLightbox] = useState(null); // { images, index }

  const openImage = (images, index) => setLightbox({ images, index });
  const setLightboxIndex = (updater) =>
    setLightbox((lb) => ({ ...lb, index: typeof updater === "function" ? updater(lb.index) : updater }));

  return (
    <div className="App grain">
      <Toaster position="top-center" richColors />
      <Navbar />
      <Hero />
      <Brands />
      <Projects onOpenVideo={setVideoProject} onOpenImage={openImage} />
      <Services />
      <Weddings onOpenImage={openImage} />
      <Process />
      <Skills />
      <Testimonials />
      <About />
      <Contact />
      <Footer />
      <FloatingContact />

      {videoProject && (
        <VideoModal project={videoProject} onClose={() => setVideoProject(null)} />
      )}
      {lightbox && (
        <Lightbox
          images={lightbox.images}
          index={lightbox.index}
          setIndex={setLightboxIndex}
          onClose={() => setLightbox(null)}
        />
      )}
    </div>
  );
}

export default App;
